import { message } from 'antd';
import i18next from 'i18next';

const copyToClipboard = async (value: string) => {
  try {
    await navigator.clipboard.writeText(value);
    message.success(i18next.t('CopySuccess'));
  } catch {
    message.error(i18next.t('CopyFailed'));
  }
};

export default {
  copyToClipboard,
};
